/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Button from './Button/index'
import Canvas from './Canvas/index'
import Label from './Label/index'
import Loader from './Loader/index'
import Measure from 'DesignSystem/Measure/index'
import Overlay from './Overlay/index'
import OverlayGrid from './OverlayGrid/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import Video from 'DesignSystem/Video/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content",
  isVideoInitialized,
  backgroundColorBackground,
  backgroundColorForeground,
  showOverlay,
  currentInstructions,
  measureWrapperRef,
  onResize,
  containerHeight,
  videoRef,
  videoHidden,
  onCanPlay,
  onPlay,
  overlayRef,
  isPlaced,
  preview,
  canvasRef,
  landmarksRef,
  buttonText,
  handleClick
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={!isVideoInitialized}>
<Loader
  viewPath={`${viewPath}/Loader`}
 text="Loading camera"
 backgroundColorBackground={backgroundColorBackground}
 backgroundColorForeground={backgroundColorForeground}
/>
</fromFlow.When>
<fromFlow.When is={showOverlay}>
<Label
  viewPath={`${viewPath}/Label`}
 marginTop={13}
 marginBottom={13}
 text={currentInstructions}
/>
</fromFlow.When>
<Measure
  viewPath={`${viewPath}/Measure`}
 innerRef={measureWrapperRef}
 onResize={onResize}
 height={isVideoInitialized ? containerHeight : "0px"}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--h-1-Z1Yf8zk': typeof containerHeight === 'number' ? `${containerHeight}px` : containerHeight}}
 className={`views-block ${styles.Vertical1}`}
>
<Video
  viewPath={`${viewPath}/Video`}
 innerRef={videoRef}
 hidden={videoHidden}
 onCanPlay={onCanPlay}
 onPlay={onPlay}
 playsInline={true}
 muted={true}
 height={containerHeight}
/>
</div>
<fromFlow.When is={showOverlay}>
<Overlay
{...childProps}
  viewPath={`${viewPath}/Overlay`}
 innerRef={overlayRef}
 videoHidden={videoHidden}
 isPlaced={isPlaced}
/>
</fromFlow.When>
<fromFlow.When is={!showOverlay}>
<OverlayGrid
{...childProps}
  viewPath={`${viewPath}/OverlayGrid`}
 hidden={videoHidden}
/>
</fromFlow.When>
<img
  data-testid="Content.Image"
  data-view-path={viewPath}
 alt={""}
 src={preview}
 hidden={!preview}
 className={`views-block ${styles.Image}`}
/>
<Canvas
{...childProps}
  viewPath={`${viewPath}/Canvas`}
 innerRef={canvasRef}
/>
<Canvas
{...childProps}
  viewPath={`${viewPath}/Canvas`}
 innerRef={landmarksRef}
/>
</React.Fragment>
)}
</Measure>
<fromFlow.When is={isVideoInitialized}>
<Button
  viewPath={`${viewPath}/Button`}
 text={buttonText}
 onClick={handleClick}
/>
</fromFlow.When>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 onPress={handleClick}
 keys="enter"
/>
</div>
{children}
</React.Fragment>)
}